var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 3.43A3.49 3.49 0 0 0 11.07 0h-7.6A3.46 3.46 0 0 0 0 3.5v7.58a3.5 3.5 0 0 0 3.42 3.5A3.49 3.49 0 0 0 6.9 18h7.64A3.46 3.46 0 0 0 18 14.52v-7.6a3.5 3.5 0 0 0-3.47-3.5ZM3.43 6.92v6.24a2.07 2.07 0 0 1-2.04-2.08V3.5A2.1 2.1 0 0 1 3.47 1.4h7.56a2.08 2.08 0 0 1 2.07 2.03H6.92a3.47 3.47 0 0 0-3.5 3.49Zm13.14 7.59a2.1 2.1 0 0 1-2.04 2.09h-7.6a2.08 2.08 0 0 1-2.09-2.1V6.93a2.1 2.1 0 0 1 2.08-2.09h7.61a2.08 2.08 0 0 1 2.04 2.09v7.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 10.02H11.4V8.16a.7.7 0 0 0-.7-.7.7.7 0 0 0-.69.7v1.86H8.05a.7.7 0 0 0-.7.7.7.7 0 0 0 .7.7H10v1.85a.7.7 0 0 0 .69.7.7.7 0 0 0 .7-.7v-1.86h1.94a.7.7 0 0 0 .7-.7.7.7 0 0 0-.7-.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatemedium);
export default __webpack_public_path__ + "static/media/duplicate.medium.a9c3338fca51e7545d2c5665c5876a91.svg";
export { ForwardRef as ReactComponent };